import ArrowCounterClockwise from './src/arrow-counter-clockwise-combined';
export default ArrowCounterClockwise;